import React from 'react';
import { TbMapPin } from 'react-icons/tb';
import ButtonPrimary from '../../Form/ButtonPrimary';

interface CardAddressProps {
    address: any;
    onClick: CallableFunction;
}

const CardAddress = ({address, onClick}: CardAddressProps) => {

    return (
        <>
            <div className="flex items-center gap-1 font-semibold text-base"><TbMapPin size={20} /> { address.type }</div>
            <div className="text-gray-500">{ address.address }</div>
            <div><ButtonPrimary outline onClick={() => {}} className="w-full text-sm">Pedir aqui</ButtonPrimary></div>
        </>
        )
    }

export default CardAddress;